// src/components/DiscourseEmbed

import React from 'react';

const DiscourseEmbed = () => {
  return (
    <iframe
      src="https://forums.trackcopr.com"
      title="Discourse Forum"
      style={{
        width: '100%',
        height: '100vh', // Adjust height as needed
        border: 'none',
        overflow: 'auto',
      }}
      frameBorder="0"
      allowFullScreen
      sandbox='allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'
      loading='lazy'
    />
  );
};

export default DiscourseEmbed;
